import React from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';
import {VisualizationInstance} from '../../../model/viz/VisualizationInstance';

import './GroupTableViz.scss';
import {Switch} from "@blueprintjs/core";
import {AbstractTableVizStateProps, ColumnDefinition} from "../table/AbstractTableViz";
import {SeparatedComponents} from "../../../../component/SeparatedComponents";
import {BlankSeparator} from "../../../../component/BlankSeparator";
import {EditorItem} from "../../../../component/editor/EditorItem";
import {DataRenderer} from "../../../../component/table/DataRenderer";
import _ from "lodash";
import {TableDatasetDisplay, TableHeaderRenderer} from "../../../../component/table/Table";


interface GroupTableVizStateProps extends AbstractTableVizStateProps {
    expandedSections: Set<number>;
};


interface GroupTableVizComponentProps extends WithTranslation {
    viz: VisualizationInstance
    onValueChanged: (prop: string, key: string, value: any) => void,
    editorData?: any
}

export class GroupTableVizEditorComponent extends React.PureComponent<GroupTableVizComponentProps> {
    private dataRenderer: DataRenderer;


    constructor(props: GroupTableVizComponentProps, context: any) {
        super(props, context);
        this.dataRenderer = new DataRenderer(null, this.props.t);
    }

    onChange = (param: string, newValue: any) => {
        this.props.onValueChanged('uiParams', param, newValue);
    };


    render() {
        const {t, editorData} = this.props;
        const showPercentagesValue = this.props.editorData.uiParams.showPercentages || false;
        return <SeparatedComponents separator={<BlankSeparator vertical={true}/>}>
            <EditorItem title={null}>
                {this.props.viz.definition.params.columns
                    .filter(column => column["@type"] !== "aggregation")
                    .map((column, index) => {
                        const value = this.getValue(column.name, 'visible', true);
                        let result = <Switch checked={value}
                                             label={t('dashboard.editor.grouptable.showColumn', {column: this.getLabel(column)})}
                                             onChange={(event) => this.onChange('columns.' + column.name + '.visible', !value)}/>
                        return result
                    })}
                <Switch checked={showPercentagesValue}
                        label={t('dashboard.editor.grouptable.showPercentages')}
                        onChange={(event) => this.onChange('showPercentages', !showPercentagesValue)}/>

            </EditorItem>
        </SeparatedComponents>;
    }

    private getLabel(column: ColumnDefinition): string {
        const columnDef = this.dataRenderer.dataColumnRenderers[column.name];
        const renderer = columnDef?.editorLabel;
        if (_.isNil(renderer)) {
            return column.name;
        }

        if (_.isFunction(renderer)) {
            return (renderer as ((column:  TableDatasetDisplay<any>)=> string))(columnDef as TableDatasetDisplay<any>);
        }

        return this.props.t(renderer as string);
    }

    private getValue(column: string, suffix: string, defaultValue: any) {
        return this.props.editorData.uiParams.columns?.[column]?.[suffix] ?? defaultValue;
    }

}


export const GroupTableVizEditor = withTranslation()(GroupTableVizEditorComponent);